import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import axios, { AxiosResponse, AxiosError } from 'axios';
import {
    STORE_MESSAGETYPE_SUPPORT,
    STORE_REFMESSAGEID_SUPPORT,
    STORE_MESSAGES_SUPPORT,
    STORE_SUPPORT_CREATESUPPORTATTMSG,
    AttachementSupportData,
    STORE_SUPPORT_ATTACHMENTSUPPORTDATA,
    STORE_SUPPORT_DOCID,
    STORE_SUPPORT_ORDERNO,
    STORE_SUPPORT_ORDERNO_DISABLED,
} from 'src/reducers/support';
import {
    // STORE_ERROR_MESSAGE,
    // STORE_ERROR_BAR,
    // STORE_SUCCESS_MESSAGE,
    // STORE_SUCCESS_BAR,
    STORE_SUCCESS_FILES_UPLOADED_MSG,
    STORE_SUCCESS_FILES_UPLOADED,
    STORE_ERROR_FILES_UPLOADED_MSG,
    STORE_ERROR_FILES_UPLOADED
} from '../reducers/errors';
import { push } from 'react-router-redux';

export const inputCharacterHandeling = (input: string | undefined) => {
    if (input === undefined || input === null) {
        return '';
    }
    return input.replace(/[\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/, '').replace(/\"/g, '');
};

export const saveQueryType = (querytype: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        // const customername = custname.charAt(0).toUpperCase + custname.slice(1);
        
        dispatch({ type: STORE_MESSAGETYPE_SUPPORT, querytype } as AnyAction);
        return true;
    };
};

export const saveMessages = (message: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        // const message = '';
        dispatch({ type: STORE_MESSAGES_SUPPORT, message } as AnyAction);
        return true;
    };
};

export const onFilesChange = (fileatBox: Array<File>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const messageFilesSupp: Array<File> = fileatBox.filter((file) => file.name !== '');
        fileatBox.length = 0;
        dispatch({ type: STORE_SUPPORT_CREATESUPPORTATTMSG, messageFilesSupp } as AnyAction);
    };
};

export const onFilesError = (error: Error, images: Array<File>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        // ==> console.error(error.message);
        // images.length = 0;
    };
};

export const doMessageClear = () => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const message = '';
        dispatch({ type: STORE_MESSAGES_SUPPORT, message } as AnyAction);
        return true;
    };
};

export const saveAttachment = (attachment: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_REFMESSAGEID_SUPPORT, attachment } as AnyAction);
        return true;
    };
};

export const orderno = (orderNo: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_SUPPORT_ORDERNO, orderNo } as AnyAction);
        return true;
    };
};

export const orderDisabled = (ordernoDisabled: boolean) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_SUPPORT_ORDERNO_DISABLED, ordernoDisabled } as AnyAction);
        return true;
    };
};

export const ticketGen = () => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const dusername = getState().user.userDetails.userName;
        const splitNumber = dusername.replace(/\b0+/g, '');
        const genNum = Math.floor(Math.random() * 90000) + 10000;
        const docid = `${splitNumber}${genNum}`;
        dispatch({ type: STORE_SUPPORT_DOCID, docid } as AnyAction);
        return true;
    };
};

// export const doSubmit = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     const params = {

//         columns: {
//             dusername: '',
//             supporttype: '',
//             message: ''
//         },
//         attachments: []
//     };

//     const sessionid = getState().user.userDetails.s || '';
//     params.columns.dusername = getState().user.userDetails.userName;
//     params.columns.supporttype = getState().support.querytype || '';
//     params.columns.message = getState().support.message || '';

//     params.attachments = [];

//     // if (params.columns.message === '') {
//     //     const errorBar = true;
//     //     const errorMessage = 'Message should not be blank.';
//     //     dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
//     //     dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
//     //     return;
//     // } else {
//     //     const errorBar = false;
//     //     dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
//     // }

//     await axios({
//         method: 'post',
//         url: `${getState().environment.API_URL}createSupportTicket`,
//         data: params,
//         headers: {
//             sessionid: sessionid || ''
//         },
//     }).then(async function (response: AxiosResponse) {

//         // const successBar = true;
//         // const successMessage = 'Your message was sent successfully';
//         // dispatch({ type: STORE_SUCCESS_MESSAGE, successMessage } as AnyAction);
//         // dispatch({ type: STORE_SUCCESS_BAR, successBar } as AnyAction);

//         const message = '';
//         dispatch({ type: STORE_MESSAGES_SUPPORT, message } as AnyAction);
//         dispatch(push('/app/supportticket'));

//     }).catch(function (error: AxiosError) {
//         // ==> console.error(error);

//         // const errorBar = true;
//         // const errorMessage = error.message;
//         // dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
//         // dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);

//     });
// };

export const doSubmit = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    let input = getState().support.message;
    const myAtt = getState().support.messageFilesSupp[0];
    // // ==> console.error(input, 'input1st');
    const attachments: Array<AttachementSupportData> = [];
    // // ==> console.error(myAtt, 'att');
    // const dusername = getState().user.userDetails.userName;
    // const splitNumber = dusername.replace(/\b0+/g, '');
    // const genNum = Math.floor(Math.random() * 90000) + 10000;
    // const docid = `${splitNumber}${genNum}`;
    if (myAtt) {
        // attachmentFile(input, attachments);
        const sessionid = getState().user.userDetails.s || '';

        const formDataS = new FormData();
        formDataS.append('filetoattach', myAtt);
        input = getState().support.message || `PRF - ${myAtt.name}`;
        await axios({
            method: 'post',
            url: `${getState().environment.API_URL}attachMessageFileSupport`,
            data: formDataS,
            headers: {
                orderid: getState().support.docid,
                sourcetype: 'Support',
                sessionid: sessionid || '',
                dsorderid: ''
            },
        }).then(function (response: AxiosResponse) {
            // // ==> console.error(response, 'attresponce');

            const message = '';
            dispatch({ type: STORE_MESSAGES_SUPPORT, message } as AnyAction);
            if (response.data.status) {
                attachments.push({
                    attachmentname: response.data.fileName,
                    attachfilename: `${response.data.location}/${response.data.fileName}`
                });
                const params = {

                    columns: {
                        docid: '',
                        dusername: '',
                        supporttype: '',
                        message: '',
                        status: '',
                        orderNo: ''
                    },
                    attachments: attachments
                };

                // const sessionid = getState().user.userDetails.s || '';
                params.columns.docid = getState().support.docid || '';
                params.columns.dusername = getState().user.userDetails.userName;
                params.columns.supporttype = getState().support.querytype || '';
                params.columns.message = inputCharacterHandeling(input) || (getState().support.orderNo || '');
                params.columns.status = '0';
                params.columns.orderNo = getState().support.orderNo || '';

                params.attachments = attachments;

                axios({
                    method: 'post',
                    url: `${getState().environment.API_URL}createSupportTicket`,
                    data: params,
                    headers: {
                        sessionid: sessionid || ''
                    },
                }).then(function (responseResult: AxiosResponse) {
                    // attachmentFile(dispatch, getState);
                    ticketGen();

                    // const message = '';
                    // dispatch({ type: STORE_MESSAGE_RXFORM_MESSAGE, message } as AnyAction);
                    const messageFilesSupp: Array<File> = [];
                    dispatch({ type: STORE_SUPPORT_CREATESUPPORTATTMSG, messageFilesSupp });
                    const getAttachmentData: Array<AttachementSupportData> = [];
                    dispatch({ type: STORE_SUPPORT_ATTACHMENTSUPPORTDATA, getAttachmentData } as AnyAction);
                    const orderNo = '';
                    dispatch({ type: STORE_SUPPORT_ORDERNO, orderNo } as AnyAction);
                    const successFileUploadOpen = true;
                    const successfilemsg = `Your Ticket ${getState().support.docid} has successfully Created`;
                    dispatch({ type: STORE_SUCCESS_FILES_UPLOADED_MSG, successfilemsg } as AnyAction);
                    dispatch({ type: STORE_SUCCESS_FILES_UPLOADED, successFileUploadOpen } as AnyAction);

                    setTimeout(() => dispatch(push('/app/supportticket')), 4000);
                    ticketGen();
                }).catch(function (error: AxiosError) {

                    // ==> console.error(error.message);
                    const errorFileUploadedOpen = true;
                    const errorfilemsg = error.message;
                    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
                    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
                });
            }
        }).catch(function (error: AxiosError) {

            // ==> console.error(error.message);
        });
    } else {
        // sendMessage(input, attachments);
        const params = {

            columns: {
                docid: '',
                dusername: '',
                supporttype: '',
                message: '',
                status: '',
                orderNo: ''
            },
            attachments: attachments
        };

        const sessionid = getState().user.userDetails.s || '';
        params.columns.docid = getState().support.docid || '';
        params.columns.dusername = getState().user.userDetails.userName;
        params.columns.supporttype = getState().support.querytype || '';
        params.columns.message = inputCharacterHandeling(input) || (getState().support.orderNo || '');
        params.columns.status = '0';
        params.columns.orderNo = getState().support.orderNo || '';
        params.attachments = attachments;

        await axios({
            method: 'post',
            url: `${getState().environment.API_URL}createSupportTicket`,
            data: params,
            headers: {
                sessionid: sessionid || ''
            },
        }).then(function (response: AxiosResponse) {
            // attachmentFile(dispatch, getState);
            // getMessage(dispatch, getState);
            const message = '';
            dispatch({ type: STORE_MESSAGES_SUPPORT, message } as AnyAction);
            const orderNo = '';
            dispatch({ type: STORE_SUPPORT_ORDERNO, orderNo } as AnyAction);
            const successFileUploadOpen = true;
            const successfilemsg = `Your Ticket ${getState().support.docid} has successfully Created`;
            dispatch({ type: STORE_SUCCESS_FILES_UPLOADED_MSG, successfilemsg } as AnyAction);
            dispatch({ type: STORE_SUCCESS_FILES_UPLOADED, successFileUploadOpen } as AnyAction);
            setTimeout(() => dispatch(push('/app/supportticket')), 4000);
            ticketGen();

        }).catch(function (error: AxiosError) {

            // ==> console.error(error.message);
            const errorFileUploadedOpen = true;
            const errorfilemsg = error.message;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        });
    }
};



// WEBPACK FOOTER //
// ./src/actions/supportAction.ts